import { render, staticRenderFns } from "./LancementReeducator.vue?vue&type=template&id=70905810&scoped=true"
import script from "./LancementReeducator.vue?vue&type=script&lang=js"
export * from "./LancementReeducator.vue?vue&type=script&lang=js"
import style0 from "./LancementReeducator.vue?vue&type=style&index=0&id=70905810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70905810",
  null
  
)

export default component.exports